export const Data = [
    {
        question: 'Who is Sambino?',
        answer: 'Sam (Sambino) is a software engineer with experience mainly in iOS app and game development. He also has experience in graphic design, but that obviously didnt help with his line work.' 
    },
    {
        question: 'What charity is 20% of mint funds going to?',
        answer: 'Sam is planning on donating to the International Otter Survival Fund (IOSF). They help fund multiple projects to help fight poaching and the fur/pet trades of Otters all over the world.' 
    }
];